import { HTMLProps } from "react";

import { ArrowRight } from "../../../Icons";

const CardWrapper = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-col gap-1 bg-white rounded-lg border-2 border-neutral-200 p-2" {...rest}>
      {children}
    </div>
  );
};

const CardTitle = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-row items-center mb-1 text-platform-700 text-sm gap-1 cursor-pointer" {...rest}>
      {children} <ArrowRight />
    </div>
  );
};

const CardColumns = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-row gap-2" {...rest}>
      {children}
    </div>
  );
};

const CardColumn = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-col grow" {...rest}>
      {children}
    </div>
  );
};

const CardFooter = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="flex flex-row justify-between mt-2" {...rest}>
      {children}
    </div>
  );
};

const CardStatHeader = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="text-xs" {...rest}>
      {children}
    </div>
  );
};

const CardStat = ({ children, ...rest }: HTMLProps<HTMLDivElement>) => {
  return (
    <div className="text-xl font-bold" {...rest}>
      {children}
    </div>
  );
};

export const Card = {
  Wrapper: CardWrapper,
  Title: CardTitle,
  Columns: CardColumns,
  Column: CardColumn,
  Footer: CardFooter,
  StatHeader: CardStatHeader,
  Stat: CardStat,
};
